
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/end-user-license-agreement",
      function () {
        return require("private-next-pages/terminal/end-user-license-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/end-user-license-agreement"])
      });
    }
  